import dayjs from "dayjs";
import "dayjs/locale/th";
import buddhistEra from "dayjs/plugin/buddhistEra";
import updateLocale from "dayjs/plugin/updateLocale";

dayjs.extend(buddhistEra);
dayjs.extend(updateLocale);

export default dayjs;